// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stripes-extra-padding[data-v-a1415874] {\n    padding: 10px;\n}\n.ap-projects-modal-btn-grid[data-v-a1415874] {\n    display: grid;\n    grid-template-columns: 50% 50%;\n    width: 521px;\n}\n", ""]);
// Exports
module.exports = exports;
